import { apiBaseUrl } from 'features/account/api/account'
import { TradeAreasType } from '../types'
import { TradeAreasSettingsQueryParams } from './index'
import { checkGreaterOrEqualATVersion, sanitizeSQLSource, formatSqlValueString } from '../../utils'
import dedent from 'ts-dedent'

export const generateQuery = (payload: TradeAreasSettingsQueryParams) => {
  const { mainSource, geomField, mode, type, time, distance, outputTable, atLocation, atVersion, ldsToken } = payload

  if (atVersion && checkGreaterOrEqualATVersion('1.3.0', atVersion)) {
    return dedent(`
      CALL ${atLocation}.CREATE_ISOLINES(
        ${formatSqlValueString(sanitizeSQLSource(mainSource.source))},
        '${outputTable}',
        '${geomField}',
        '${mode}',
        ${type === TradeAreasType.Distance ? distance : time},
        '${type}',
        '{}',
        '${apiBaseUrl}',
        '${ldsToken}'
      );`)
  }

  return dedent(`
    CALL ${atLocation}.CREATE_ISOLINES(
      ${formatSqlValueString(sanitizeSQLSource(mainSource.source))},
      '${outputTable}',
      '${geomField}',
      '${mode}',
      ${type === TradeAreasType.Distance ? distance : time},
      '${type}'
    );`)
}
